export const RedirectNotFoundPage = () => {
  // if (window.location.pathname.includes("safeconnect")) {
  //   window.location.href = '/safeconnect/';
  // }
  // else if (window.location.pathname.includes("gbfoods")) {
  //   window.location.href = '/gbfoods/';
  // }
  // else {
  // }
  window.location.href = "/";
};
